module.exports = __webpack_public_path__ + "img/f_ic_online.86bddf66.svg";